// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__pvYRd","rotation":"Loader_rotation__7XO6F"};